import { toast } from 'sonner'
import { fmtDate, fmtMoney } from '@/features/shared/format'
import i18n from '@/i18n'
import type { OdemeSatir } from '../types'
import { copyText, downloadCsv, downloadIcs, openPrintDocument, type PrintSection } from './fileExport'

export function printDoc(doc: { title: string; subtitle?: string; sections: PrintSection[]; note?: string }) {
  if (!openPrintDocument(doc)) toast.error(i18n.t('hr.personel.actions.popupBlocked'))
}

export function exportCsv(filename: string, headers: string[], rows: (string | number)[][]) {
  downloadCsv(filename, headers, rows)
  toast.success(i18n.t('hr.personel.actions.downloaded', { name: filename }))
}

export function exportIcs(filename: string, ev: { title: string; date: string; description?: string }) {
  downloadIcs(filename, ev)
  toast.success(i18n.t('hr.personel.actions.icsReady'))
}

export async function copyWithToast(text: string, successKey = 'hr.personel.actions.copied') {
  const ok = await copyText(text)
  if (ok) toast.success(i18n.t(successKey))
  else toast.error(i18n.t('hr.personel.actions.copyFailed'))
}

export const csvAmount = (amount: string) => Number(amount).toFixed(2).replace('.', ',')

export const fileStamp = () => new Date().toISOString().slice(0, 10)

type OdemeLike = OdemeSatir & { aciklama?: string; yontem?: string }

export function printDekont(o: OdemeLike, iban?: string) {
  const t = i18n.t.bind(i18n)
  printDoc({
    title: t('hr.personel.actions.odeme.dekontTitle'),
    subtitle: `${o.ad} · ${o.unvan}`,
    sections: [
      {
        rows: [
          [t('hr.personel.odemeGecmis.tur'), t(`hr.personel.odeme.tur.${o.tur}`)],
          [t('hr.personel.odemeGecmis.aciklama'), o.aciklama ?? `${o.donem} ${t(`hr.personel.odeme.tur.${o.tur}`)}`],
          [t('hr.personel.ucret.donem'), o.donem],
          [t('hr.personel.odemeGecmis.tarih'), o.tarih === '—' ? '—' : fmtDate(o.tarih)],
          [t('hr.personel.odemeGecmis.yontem'), o.yontem ?? 'Banka'],
          ...(iban ? ([[t('hr.personel.odemeGecmis.banka'), iban]] as [string, string][]) : []),
          [t('hr.personel.columns.durum'), t(`hr.personel.odeme.durum.${o.durum}`)],
        ],
        total: [t('hr.personel.odemeGecmis.tutar'), fmtMoney(o.tutar)],
      },
    ],
    note: `REF-${o.id.toUpperCase()}`,
  })
}

export function exportOdemeCsv(filename: string, rows: OdemeLike[]) {
  const t = i18n.t.bind(i18n)
  exportCsv(
    filename,
    [
      t('hr.personel.columns.personel'),
      t('hr.personel.columns.pozisyon'),
      t('hr.personel.odemeGecmis.tur'),
      t('hr.personel.odemeGecmis.aciklama'),
      t('hr.personel.ucret.donem'),
      t('hr.personel.odemeGecmis.tutar'),
      t('hr.personel.odemeGecmis.tarih'),
      t('hr.personel.columns.durum'),
    ],
    rows.map((o) => [
      o.ad,
      o.unvan,
      t(`hr.personel.odeme.tur.${o.tur}`),
      o.aciklama ?? '',
      o.donem,
      csvAmount(o.tutar),
      o.tarih,
      t(`hr.personel.odeme.durum.${o.durum}`),
    ]),
  )
}
